import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Collapse,
  Button,
  Form,
  Input,
  Modal,
  Space,
  Tooltip,
  Checkbox,
} from "antd";
import { uniqBy } from "lodash";
import { useHistory } from "react-router-dom";
import UserInfoCard from "../UserInfoCard/UserInfoCard";
import ModalWindow from "../ModalWindow/ModalWindow";
import { hasAccess } from "../../hasAccess";
import {
  MENU_USER_USERMANAGEMENT_WRITE,
  USERMANAGEMENT_USER_ACTIONS,
} from "../../../../lib/const/permissions";
import { ReactComponent as EditIcon } from "../../img/edit_icon.svg";
import { ReactComponent as DeleteIcon } from "../../img/delete-icon.svg";
import { UserResetPassword } from "../UserResetPassword/UserResetPassword";
import "./UserProfile.less";
import { getActiveUser } from "../../lib/getActiveUser";

const { Panel } = Collapse;

const gutter = [20, 20];

const styles = {
  card: {
    height: "60vh",
  },
  cardBody: {
    height: "54.5vh",
    overflow: "auto",
  },
  userSelectCol: {
    width: "360px",
  },
  permissionItem: {
    margin: "16px 16px 16px 0",
  },
};

const PanelTitle = (title) => <span style={{ marginLeft: 0 }}>{title}</span>;

export default function UserProfile(props) {
  const {
    user,
    handleDeleteUser,
    requirements,
    requirementsLoading,
    handleEditUserInfo,
    handleEditUserInfoStatus,
  } = props;
  const history = useHistory();
  const [visibleModalWindow, setVisibleModalWindow] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [form] = Form.useForm();

  const [allIncludedPermissions, setAllIncludedPermissions] = useState([]);
  const [allExcludedPermissions, setAllExcludedPermissions] = useState([]);
  const internalUser = user.userType === "internal";
  const externalUser = user.userType === "external";

  const { id, includedRoles, excludedRoles, includedPermissions, excludedPermissions } = user;

  useEffect(() => {
    setAllIncludedPermissions(uniqBy([...includedPermissions], "id"));
    setAllExcludedPermissions(uniqBy([...excludedPermissions], "id"));
  }, [excludedPermissions, excludedRoles, includedPermissions, includedRoles]);

  const renderModalWindow = () => {
    const isRequiredFiled = (userType) => userType === "internal";
    const onFinish = (values) => {
      const { userInfo, ...restUser } = user;

      const getBody = () => ({
        ...restUser,
        login: values.login,
        password: values.password,
        firstName: values.firstName,
        lastName: values.lastName,
        middleName: values.middleName,
        email: values.email,
      });
      handleEditUserInfo(user.id, getBody());
      setVisibleModalWindow(false);
      form.resetFields();
    };
    return (
      <ModalWindow
        visible={visibleModalWindow}
        footer={null}
        title="Редактирование данных пользователя"
        handleCancel={() => setVisibleModalWindow(false)}
        handleReset={() => setVisibleModalWindow(false)}
      >
        <Form
          form={form}
          name="basic"
          initialValues={{
            login: user?.login,
            password: user?.password,
            tenantId: user?.tenantId,
            firstName: user?.firstName,
            lastName: user?.lastName,
            middleName: user?.middleName,
            email: user?.email,
          }}
          labelCol={{ span: 5 }}
          labelAlign="left"
          onFinish={onFinish}
        >
          <Form.Item label="Фамилия" name="lastName">
            <Input placeholder="Введите фамилию" />
          </Form.Item>
          <Form.Item label="Имя" name="firstName">
            <Input placeholder="Введите имя" />
          </Form.Item>
          <Form.Item label="Отчество" name="middleName">
            <Input placeholder="Введите отчество" />
          </Form.Item>
          <Form.Item
            label="Логин"
            name="login"
            rules={[
              {
                required: isRequiredFiled(user.userType),
                message: "Пожалуйста, введите логин",
              },
            ]}
          >
            <Input placeholder="Введите логин" disabled />
          </Form.Item>
          <Form.Item
            label="E-mail"
            name="email"
            rules={[
              {
                required: isRequiredFiled(user.userType),
                message: "Пожалуйста, введите e-mail",
              },
            ]}
          >
            <Input placeholder="Введите e-mail" />
          </Form.Item>
          <Form.Item style={{ paddingTop: "20px" }}>
            <Row gutter={[14, 16]} justify="center">
              <Col>
                <Button key="add" onClick={() => setVisibleModalWindow(false)}>
                  Отмена
                </Button>
              </Col>
              <Col>
                <Button key="delete" type="primary" htmlType="submit">
                  Сохранить
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </ModalWindow>
    );
  };

  const onCheckboxChange = (e) => {
    if (e.target.checked) {
      handleEditUserInfoStatus(user.id, { enabled: true });
    } else {
      Modal.confirm({
        title: "Вы уверены, что хотите отключить пользователя?",
        width: 430,
        icon: null,
        okText: "Подтвердить",
        cancelText: "Отмена",
        onOk: () => {
          handleEditUserInfoStatus(user.id, { enabled: false });
        },
      });
    }
  };

  return (
    <>
      {renderModalWindow()}
      <Modal
        visible={isDeleteModalVisible}
        okText="Удалить"
        onCancel={() => setIsDeleteModalVisible(false)}
        onOk={() => {
          handleDeleteUser(id);
          history.push(`/`);
        }}
      >
        {externalUser
          ? "Вы действительно хотите удалить пользователя? При повторном входе пользователя его привилегии будут определяться настройками AD."
          : "Вы действительно хотите удалить пользователя?"}
      </Modal>
      <Row className="user-profile" gutter={[16, 16]} justify="flex-start">
        <Col span={8} gutter={gutter}>
          <UserInfoCard
            user={user}
            handleEditUserInfoStatus={handleEditUserInfoStatus}
            userActiveAction={
              hasAccess(MENU_USER_USERMANAGEMENT_WRITE) && (
                <Space style={{ height: 23 }}>
                  {internalUser && (
                    <Checkbox
                      checked={getActiveUser(user)}
                      style={{ marginRight: "-2px" }}
                      onChange={onCheckboxChange}
                    />
                  )}
                </Space>
              )
            }
            userActions={
              hasAccess(MENU_USER_USERMANAGEMENT_WRITE, USERMANAGEMENT_USER_ACTIONS) && (
                <Space style={{ height: 23 }}>
                  {!externalUser && (
                    <Tooltip title="Редактировать пользователя">
                      <Button
                        className="iconButton"
                        style={{ marginLeft: "auto" }}
                        icon={<EditIcon />}
                        onClick={() => setVisibleModalWindow(true)}
                      />
                    </Tooltip>
                  )}
                  <Tooltip title="Удалить пользователя">
                    <Button
                      className="iconButton"
                      style={{ marginLeft: "auto" }}
                      icon={<DeleteIcon />}
                      onClick={() => setIsDeleteModalVisible(true)}
                    />
                  </Tooltip>
                </Space>
              )
            }
          />
          <UserResetPassword
            user={user}
            requirements={requirements}
            requirementsLoading={requirementsLoading}
          />
        </Col>
        <Col flex={1}>
          <Card
            title="Роли и привилегии пользователя"
            style={styles.card}
            bodyStyle={styles.cardBody}
          >
            <Collapse expandIconPosition="right" bordered={false} ghost>
              {includedRoles.map((item) => (
                <Panel collapsible={false} header={PanelTitle(item.alias)} key={item.id}>
                  {item.includedPermissions.map((permission) => (
                    <div style={styles.permissionItem} key={permission.id}>
                      <i className="included" />
                      <div>{permission.alias}</div>
                    </div>
                  ))}
                  {item.excludedPermissions.map((permission) => (
                    <div style={styles.permissionItem} key={permission.id}>
                      <i className="excluded" />
                      <div>{permission.alias}</div>
                    </div>
                  ))}
                </Panel>
              ))}
            </Collapse>
            {allIncludedPermissions.map((item) => (
              <Row key={item.id} style={styles.row}>
                <span style={styles.permissionItem} className="included">
                  {item.alias}
                </span>
              </Row>
            ))}
            {allExcludedPermissions.map((item) => (
              <Row key={item.id} style={styles.row}>
                <span style={styles.permissionItem} className="excluded">
                  {item.alias}
                </span>
              </Row>
            ))}
          </Card>
        </Col>
      </Row>
    </>
  );
}
